
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { DatabaseInterface, DatabaseRepositoryInterface } from '@/services/Database/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'databaseRepository',
  ],
})
export default class DeleteDatabaseDialog extends Vue {
  @Prop() private readonly database!: DatabaseInterface;

  private databaseRepository!: DatabaseRepositoryInterface;
  private visible: boolean = true;

  get message(): string {
    return `Are you sure you want to delete database ${this.database.name}?`;
  }

  private async deleteDatabase(): Promise<void> {
    try {
      await this.databaseRepository.deleteDatabase(this.database.id);
      this.$successDialog.show(`Database ${this.database.name} deleted successfully`);
      this.$emit('database-deleted', this.database)
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message || e.message);
    }
  }

  private destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
